import React from 'react';
import { Helmet } from 'react-helmet-async';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { FullViewProps } from '../types';
import { VideoPlayer } from '../../../VideoPlayer/LoadableVideoPlayer';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { getSource } from '../../_helpers';
import s from './Film.scss';

export const FilmFullView: React.FC<FullViewProps> = ({
  deviation,
  height,
  width,
}) => {
  const videoFile = getSource(
    DeviationMediaService.getMediaByType(deviation, 'video')
  );
  if (!videoFile) {
    return null;
  }

  const previewFile = DeviationMediaService.getDeviationFile(
    deviation,
    'preview'
  );

  return (
    <ErrorBoundary debugComponent="FillFullView">
      <Helmet>
        {previewFile && (
          <link rel="preload" href={previewFile.src} as="image" />
        )}
        <link rel="preload" href={videoFile.src} as="video" />
      </Helmet>
      <div>
        <div className={s['root']} style={{ width, height }}>
          <VideoPlayer
            width={width}
            height={height}
            src={videoFile.src}
            loadingCover={previewFile && previewFile.src}
            autoPlay
            muted
          />
        </div>
      </div>
    </ErrorBoundary>
  );
};
FilmFullView.displayName = 'FilmFullView';

export default FilmFullView;
